import { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getVmsSettings } from '../../../redux/actions/SocietyPortal/VmsAction/VmsAction';
import { createVisitor } from '../../../redux/actions/SocietyPortal/VisitorAction/VisitorAction';
import { selectedSocietyStorer } from '../../../utils/webStorer';
import { notify } from '../../../utils/notification';
import {
    SOCIETY_PORTAL,
    SOCIETY_PORTAL_VISITORS,
    SOCIETY_PORTAL_VISITORS_VIEW,
} from '../../../Routing/routes';
import VisitorForm from './VisitorForm';

const AddVisitor = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();

    const { createVisitorLoading } = useSelector(state => state.VisitorReducer || {});
    // visitor_id_proof_required is stored but never read server-side, so the
    // form is the only place it can take effect.
    const settings = useSelector(state => state.VmsReducer?.settings?.data);
    const requireIdProof = settings?.visitor_id_proof_required === true || settings?.visitor_id_proof_required === 1;

    useEffect(() => {
        if (societyId && !settings) dispatch(getVmsSettings({ societyId }));
    }, [dispatch, societyId, settings]);

    const backToList = () => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_VISITORS);

    const handleSubmit = (payload) => {
        // society_id is required on the body: the controller has no working
        // fallback for it, so without this the insert fails on the NOT NULL
        // column. Catch it here rather than letting the API 400.
        if (!societyId) {
            notify('error', 'No society selected. Pick a society before registering a visitor.');
            return;
        }
        dispatch(createVisitor({
            society_id: Number(societyId),
            ...payload,
            onSuccess: (res) => {
                const id = res?.data?.visitor_id;
                // Land on the new profile so the next action (block, add notes)
                // is one click away instead of a hunt through the list.
                if (id) navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_VISITORS_VIEW.replace(':id', id));
                else backToList();
            },
        }));
    };

    return (
        <div className="tw-p-5 tw-bg-gradient-to-br tw-from-gray-50 tw-to-slate-50 tw-min-h-screen">
            <div className="tw-w-full">
                <button
                    onClick={backToList}
                    className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-600 hover:tw-text-gray-800 tw-mb-3"
                >
                    <Icon icon="mdi:arrow-left" /> Back to Visitors
                </button>

                <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm">
                    <div className="tw-p-4 tw-border-b tw-border-gray-100">
                        <h1 className="tw-mb-0 tw-text-base tw-font-bold tw-text-gray-800">Register Visitor</h1>
                        <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-0.5">
                            Create the master record once — visits, pre-approvals and gate passes attach to it
                        </p>
                    </div>
                    <div className="tw-p-5">
                        <VisitorForm
                            mode="create"
                            onSubmit={handleSubmit}
                            onCancel={backToList}
                            submitting={createVisitorLoading}
                            requireIdProof={requireIdProof}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddVisitor;
